/* PERTU — scripts propios (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pt-reveal:not(.pt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('pt-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pt-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce || window.innerWidth < 990) return;
    var imgs = document.querySelectorAll('[data-pt-parallax]');
    if (!imgs.length) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var speed = parseFloat(img.getAttribute('data-pt-parallax')) || 0;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-r.top * speed / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  function initCountdowns() {
    document.querySelectorAll('[data-pt-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-pt-countdown')).getTime();
      if (isNaN(end)) { el.style.display = 'none'; return; }
      var cells = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 86400000), h = Math.floor(diff / 3600000) % 24, m = Math.floor(diff / 60000) % 60, s = Math.floor(diff / 1000) % 60;
        if (cells.d) cells.d.textContent = pad(d);
        if (cells.h) cells.h.textContent = pad(h);
        if (cells.m) cells.m.textContent = pad(m);
        if (cells.s) cells.s.textContent = pad(s);
        if (diff <= 0) { el.style.display = 'none'; clearInterval(t); }
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var val = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!fmt) return val;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return val;
    });
  }

  function initProduct() {
    var root = document.querySelector('[data-pt-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-pt-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var fmt = root.getAttribute('data-money-format');
    var idInput = root.querySelector('input[name="id"]');
    var priceNow = root.querySelectorAll('[data-pt-price]');
    var priceWas = root.querySelector('[data-pt-compare]');
    var save = root.querySelector('[data-pt-save]');
    var atcs = document.querySelectorAll('[data-pt-atc]');
    var labelAdd = root.getAttribute('data-label-add'), labelSold = root.getAttribute('data-label-soldout'), labelNA = root.getAttribute('data-label-unavailable');

    // Galería
    var main = root.querySelector('[data-pt-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pt-thumb]'));
    var current = Math.max(0, thumbs.findIndex(function (x) { return x.classList.contains('is-active'); }));
    var vbox = root.querySelector('[data-pt-video]'), vid = vbox && vbox.querySelector('video');
    var sound = root.querySelector('[data-pt-sound]');
    if (sound && vid) sound.addEventListener('click', function () { vid.muted = !vid.muted; sound.classList.toggle('is-on', !vid.muted); if (!vid.muted) vid.play().catch(function () {}); });
    function show(i) {
      if (!thumbs.length || !main) return;
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      if (t.getAttribute('data-type') === 'video') {
        if (vbox) { vbox.hidden = false; if (vid) vid.play().catch(function () {}); }
        return;
      }
      if (vbox) { vbox.hidden = true; if (vid) vid.pause(); }
      main.style.opacity = 0;
      setTimeout(function () { main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset') || ''; main.alt = t.getAttribute('data-alt') || ''; main.style.opacity = 1; }, 150);
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-pt-prev]'), next = root.querySelector('[data-pt-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (main) {
      var x0 = null, swipe = main.parentNode;
      swipe.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      swipe.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1)); x0 = null; });
    }

    // Variantes
    var fieldsets = root.querySelectorAll('[data-pt-option]');
    function selected() {
      var vals = [];
      fieldsets.forEach(function (fs) { var c = fs.querySelector('input:checked'); vals.push(c ? c.value : null); var lbl = fs.querySelector('[data-pt-option-value]'); if (lbl && c) lbl.textContent = c.value; });
      return vals;
    }
    function markAvailability(vals) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = vals.slice(); test[idx] = inp.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, j) { return o === test[j]; }); });
          var l = fs.querySelector('label[for="' + inp.id + '"]'); if (l) l.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function update() {
      var vals = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
      markAvailability(vals);
      if (!v) { atcs.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = labelNA; }); return; }
      idInput.value = v.id;
      priceNow.forEach(function (p) { p.textContent = money(v.price, fmt); });
      if (priceWas) { if (v.compare_at_price > v.price) { priceWas.textContent = money(v.compare_at_price, fmt); priceWas.hidden = false; } else priceWas.hidden = true; }
      if (save) { if (v.compare_at_price > v.price) { save.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; save.hidden = false; } else save.hidden = true; }
      atcs.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? labelAdd : labelSold; });
      if (v.featured_media_id) {
        var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.featured_media_id; });
        if (idx > -1) show(idx);
      }
      if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    // Cantidad
    var qty = root.querySelector('[data-pt-qty]');
    root.querySelectorAll('[data-pt-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () { var n = parseInt(qty.value, 10) || 1; qty.value = Math.max(1, n + parseInt(b.getAttribute('data-pt-qty-btn'), 10)); });
    });

    // Añadir al carrito (abre el cajón del carrito de Dawn si existe)
    var form = root.querySelector('form[data-pt-form]');
    var msg = root.querySelector('[data-pt-msg]');
    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return; // envío normal → /cart
      e.preventDefault();
      atcs.forEach(function (b) { b.classList.add('is-loading'); });
      if (msg) msg.textContent = '';
      var body = { items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }], sections: drawer.getSectionsToRender().map(function (s) { return s.id; }), sections_url: window.location.pathname };
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
          var items = res.items && res.items[0] ? res.items[0] : res;
          items.sections = res.sections;
          drawer.classList.remove('is-empty');
          drawer.renderContents(items);
        })
        .catch(function () { form.submit(); })
        .finally(function () { atcs.forEach(function (b) { b.classList.remove('is-loading'); }); });
    });

    // Barra fija móvil
    var sticky = document.querySelector('[data-pt-sticky]');
    var mainBtn = root.querySelector('.pt-atc');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainBtn);
      sticky.querySelector('[data-pt-atc]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  }

  function init() { initReveal(); initParallax(); initCountdowns(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCountdowns(); });
})();
